import { Injectable } from '@angular/core';
import { User } from '../models/auth.models';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { jwtDecode } from 'jwt-decode';
import { environment } from '../../../environments/environment';
import { TokenStorageService } from './token-storage.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({ providedIn: 'root' })

/**
 * Auth-service Component
 */
export class AuthenticationService {

  constructor(private http: HttpClient, 
              private tokenStorageService: TokenStorageService) {

  }

  /**
   * Performs the auth
   * @param email email of user
   * @param password password of user
   */
  login(email: string, password: string) {
    return this.http.post<any>(
      `${environment.API_URL}/auth/token`,
      {
        username: email,
        password: password,
      },
      httpOptions
    );
  }

  /**
   * Refresh the token
   */
  refreshToken() {

    let currentUser = this.currentUser();

    return this.http.post<any>(
      `${environment.API_URL}/auth/refresh-token`,
      {
        refreshToken: currentUser.refreshToken,
      },
      httpOptions
    );
  }

  /**
   * Performs the auth chalelnge
   * @param email email of user
   * @param password password of user
   * @param sessionToken session token
   */
  challengeNewPassword(email: string, password: string, sessionToken: string) {
    return this.http.post<any>(
      `${environment.API_URL}/auth/challenge/new-password`,
      {
        username: email,
        password: password,
        session: sessionToken,
      },
      httpOptions
    );
  }

  /**
   * Decode the jwt token
   * @param token token
   */
  decodeJwtToken(token: string) {
    return jwtDecode(token);
  }

  /**
   * Returns the current user
   */
  public currentUser(): any {

    const currentUser = this.tokenStorageService.getCurrentUser();

    if (currentUser) {
      return currentUser as User;
    }

    return null;
  }

  /**
   * Returns if exist any user authenticated
   * @returns true if authenticated
   */
  public isAuthenticated(): boolean {
    const currentUser = this.currentUser();

    if(currentUser && currentUser.expiresIn > new Date().getTime() / 1000) {
      return true;
    }

    return false;
  }

  /**
   * Logout the user
   */
  logout() {
    this.tokenStorageService.clearAll();
  }
}
